import axios, {AxiosError, AxiosResponse} from 'axios'

export class Api{
    public Client: any
    public currentRetryCount: number = 0
    constructor() {
        this.Client = axios.create({
            baseURL: 'https://api.messagehub.ca',
           // baseURL: 'http://localhost:50377',
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        this.Client.interceptors.response.use(null, (error: AxiosError) => {
            if (error.config && error.response && error.response.status === 401) {
                sessionStorage.removeItem('verifiedAuthStatus')
                window.location.assign('/login')
                return Promise.reject(error);

            }
        })
    }
}
export default Api

